import { intl } from '../../utils/intl';
const t = (id) => intl.formatMessage({ id });

export default {
  basic_info: {
    separate_rpm_renders: {
      label: t('assetSchema.separate_rpm_renders.label'),
      placeholder: '',
      type: 'boolean'
    },
    virtual_tour_link: {
      label: t('assetSchema.virtual_tour_link.label'),
      placeholder: t('assetSchema.virtual_tour_link.placeholder'),
      type: "text",
      validation: /^(http|https):\/\/[^ "]+$/
    },
    white_box_link: {
      label: t('assetSchema.white_box_link.label'),
      placeholder: t('assetSchema.white_box_link.placeholder'),
      type: "text",
      validation: /^(http|https):\/\/[^ "]+$/
    },
    actual_sq_ft: {
      label: t('assetSchema.actual_sq_ft.label'),
      publicLabel: t('assetSchema.actual_sq_ft.publicLabel'),
      placeholder: t('assetSchema.actual_sq_ft.placeholder'),
      type: "number",
      required: true,
      viewModeRenderOptions: {
        append: "'"
      }
    },
    overall_actual_sq_ft: {
      label: t('assetSchema.overall_actual_sq_ft.label'),
      publicLabel: t('assetSchema.overall_actual_sq_ft.publicLabel'),
      placeholder: t('assetSchema.overall_actual_sq_ft.placeholder'),
      type: "number",
      required: false,
      enabled: true,
      visible: true,
      photosEnabled: false
    },
    tax_pin: {
      label: t('assetSchema.tax_pin.label'),
      placeholder: '19-04-251-021',
      enabled: false,
      type: 'number'
    },
    total_depth_of_space: {
      label: t('assetSchema.total_depth_of_space.label'),
      publicLabel: t('assetSchema.total_depth_of_space.publicLabel'),
      placeholder: t('assetSchema.total_depth_of_space.placeholder'),
      type: "measurement",
      required: true
    },
    unit_overview: {
      label: t('assetSchema.headers.unit_overview'),
      sales_area: {
        label: t('assetSchema.sales_area'),
        placeholder: "3672’",
        type: "number",
        enabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      stock_room: {
        label: t('assetSchema.stock_room'),
        placeholder: "116’",
        type: "number",
        enabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      exterior_doors: {
        label: t('assetSchema.exterior_doors'),
        placeholder: "5",
        type: "number",
        enabled: false,
        visible: false,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      other: {
        label: t('assetSchema.unit_overview.other'),
        placeholder: "1834’",
        type: "number",
        enabled: false,
        viewModeRenderOptions: {
          append: "'"
        }
      }
    },
    flooring_square_footage: {
      label: t('assetSchema.flooring_square_footage'),
      concrete: {
        label: t('assetSchema.concrete'),
        placeholder: "3672’",
        type: "number",
        viewModeRenderOptions: {
          append: "'"
        }
      },
      tile: {
        label: t('assetSchema.tile'),
        placeholder: "116’",
        type: "number",
        viewModeRenderOptions: {
          append: "'"
        }
      },
      other: {
        label: t('assetSchema.flooring.other'),
        placeholder: "1834’",
        type: "number",
        viewModeRenderOptions: {
          append: "'",
          paren: 'basic_info.flooring_square_footage.type_of_other'
        }
      },
      carpet: {
        label: t('assetSchema.carpet'),
        placeholder: "3672’",
        type: "number",
        viewModeRenderOptions: {
          append: "'"
        }
      },
      total: {
        label: t('assetSchema.flooring.total.label'),
        publicLabel: t('assetSchema.flooring.total.publicLabel'),
        placeholder: "4032’",
        type: "number",
        required: true,
        viewModeRenderOptions: {
          append: "'"
        }
      },
      type_of_other: {
        label: t('assetSchema.flooring.type_of_other.label'),
        type: "select",
        isMulti: true,
        options: [
          { label: 'Laminate', value: 'Laminate' },
          { label: 'Linoleum', value: 'Linoleum' },
          { label: 'Metal', value: 'Metal' },
          { label: 'Rubber', value: 'Rubber' },
          { label: 'Vinyl', value: 'Vinyl' },
          { label: 'Wood', value: 'Wood' },
          { label: 'NA', value: 'NA' }
        ]
      },
      unit: {
        label: t('assetSchema.flooring.unit.label'),
        publicLabel: t('assetSchema.flooring.unit.publicLabel'),
        placeholder: "4128’",
        type: "number",
        required: true,
        viewModeRenderOptions: {
          append: "'"
        }
      }
    }
  }
}
